import { Link } from "react-router-dom";
import styles from "./Button.module.css";

export default function Button({
  to,
  href,
  onClick,
  variant = "primary",
  size = "md",
  children,
  className = "",
  ...rest
}) {
  const cls = [styles.btn, styles[variant], styles[size], className]
    .filter(Boolean)
    .join(" ");
  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  if (href) return <a href={href} className={cls} target="_blank" rel="noopener" {...rest}>{children}</a>;
  return <button type="button" className={cls} onClick={onClick} {...rest}>{children}</button>;
}
